import { useMemo } from 'react';

import { CraftsmanPropertyHeader } from '../../../components/CraftsmanPropertyHeader/CraftsmanPropertyHeader.tsx';

export const useHeaderByID = () =>
  useMemo(
    () =>
      ({ id }: { id: string }) => {
        const isSubject = id === 'subject' || id === 'subjectArv';
        return <CraftsmanPropertyHeader propertyId={id} hideActions={!isSubject} />;
      },
    [],
  );
